/* ==========================================================================
   Rising Health — quick add

   ONE delegated listener for every add-to-cart button on the page, wherever
   it is: the bestsellers carousel, the symptom tiles, the A–Z plate. Adding a
   fourth place to press it costs nothing here.

   ── IT SPEAKS THE THEME'S OWN CART PROTOCOL ────────────────────────────────
   Pebble's cart drawer and cart bubble both listen for `cart:update`, and the
   payload they expect is the one assets/events.js defines: a plain Event with
   a `detail` property assigned after construction — NOT a CustomEvent, which
   is why this file builds the event by hand rather than using CustomEvent.
   Sections to re-render are collected first by dispatching
   `cart:grouped-sections` with a mutable array, exactly as
   assets/product-form.js does, so the drawer refreshes with real markup
   instead of going stale until the next page load.

   ── IT NEVER LIES ABOUT WHAT HAPPENED ──────────────────────────────────────
   Shopify answers a rejected add with HTTP 200 and a `status` field, so
   response.ok is not the test. It does not sit there saying "Added".

   ── IT NEVER LEAVES THE PAGE (changed 2026-09-11) ──────────────────────────
   A rejected add used to navigate the shopper to the product page
   (window.location.href = product.url) so the rejection reason was visible.
   On the cart page's own "Other products people buy" shelf that read as
   "pressing Add to cart takes you away from your cart instead of adding
   anything" — the one place a redirect-away is least welcome. A rejection
   now surfaces IN the button (the qad__face--err face, Shopify's own
   message when it has one) and the button returns to idle; nothing
   navigates, anywhere this control is used.
   ========================================================================== */
(function () {
  "use strict";

  var BUSY = "is-working";
  var DONE = "is-done";

  function addUrl() {
    if (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) {
      return FoxTheme.routes.cart_add_url;
    }
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + "cart/add.js";
    }
    return "/cart/add.js";
  }

  /**
   * Ask every cart-rendering component on the page which section it needs
   * back. The array is mutated in place by the listeners — that is the
   * contract in assets/events.js, and it is why this cannot be a CustomEvent
   * with a frozen detail.
   */
  function groupedSections() {
    var ids = [];
    try {
      var ev = new Event("cart:grouped-sections", { bubbles: true });
      ev.detail = { sections: ids };
      document.dispatchEvent(ev);
    } catch (e) {
      /* An older engine without Event constructor options: no sections, and
         the cart bubble still updates. Degraded, not broken. */
    }
    var seen = {};
    var out = [];
    for (var i = 0; i < ids.length; i++) {
      if (ids[i] && !seen[ids[i]]) {
        seen[ids[i]] = 1;
        out.push(ids[i]);
      }
    }
    return out;
  }

  function announce(btn, cart) {
    var ev;
    try {
      ev = new Event("cart:update", { bubbles: true });
    } catch (e) {
      return;
    }
    ev.detail = {
      resource: cart,
      sourceId: "rh-quick-add",
      data: {
        source: "rh-quick-add",
        itemCount: 1,
        isIncremental: true,
        variantId: btn.dataset.variant,
        sections: cart && cart.sections,
      },
    };
    btn.dispatchEvent(ev);
  }

  var ERR = "is-err";

  function settle(btn) {
    btn.classList.remove(BUSY);
    btn.classList.add(DONE);
    btn.disabled = false;
    window.setTimeout(function () {
      btn.classList.remove(DONE);
    }, 2200);
  }

  /**
   * A rejected or failed add: state the reason on the button itself and
   * return to idle. Never navigates — see the file header, 2026-09-11.
   */
  function fail(btn, message) {
    var textEl = btn.querySelector("[data-qad-err-text]");
    if (textEl) textEl.textContent = message || "Try again";
    btn.classList.remove(BUSY);
    btn.classList.add(ERR);
    btn.disabled = false;
    window.setTimeout(function () {
      btn.classList.remove(ERR);
    }, 2600);
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-qad]") : null;
    if (!btn) return;

    /* The tiles and the plate wrap the whole card in a link. Without both of
       these, adding to the cart also navigates away from the page you were
       adding from. */
    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains(BUSY) || btn.classList.contains(DONE)) return;

    var id = btn.dataset.variant;
    if (!id) return;

    btn.classList.add(BUSY);
    btn.disabled = true;

    var body = { id: id, quantity: 1 };
    var sections = groupedSections();
    if (sections.length) body.sections = sections.join(",");

    fetch(addUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        // A rejected add is a 200 with a `status` field. Do not celebrate it.
        if (!data || data.status) {
          fail(btn, data && data.message);
          return;
        }
        settle(btn);
        announce(btn, data);
      })
      .catch(function () {
        fail(btn);
      });
  });
})();
